'use strict';

const Slide = require('./slide');
const template = require('../templates/welcome-slide.hbs');

module.exports = class extends Slide {
  constructor(context = {}) {
    super(template, context);
    this._mainlocationid = context.locationId;
    this._locationKiosk = context.locationKiosk;
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterLeave', this._setmainlocation);
    this.on('afterLeave', this._settime);
    this.on('beforeLeave', this._clearForm);
    if(this._locationKiosk){
      this.on('afterLeave', this._getPrinterType);
    }
    localStorage.removeItem("printer_type");
    localStorage.removeItem("phone_no");
    localStorage.removeItem("unique_identification_label");
    localStorage.removeItem('regnr');
    localStorage.removeItem('custom_signature_value');
    localStorage.removeItem('contact_to_visit');
    localStorage.removeItem('unique_identification_number');
    localStorage.removeItem('luprefnr');
  }

  _stopIdleTimer(){
  	if(_idleintervalHandler != undefined){
    	clearInterval(_idleintervalHandler);
    }
  }

  _settime(e){
    var dt = new Date().getTime();
     localStorage.setItem("checkin_time", dt);
  }

  _setmainlocation(){
    localStorage.removeItem("phone_no");
    window.localStorage.setItem("main_location_id",this._mainlocationid);
    this._slideshow._getFormLables(this._mainlocationid);
    $("#label_location_id").val(this._mainlocationid);
    $("#label_exist_code").val('0');
    $("#form_field_signature_id").val('0');
  }

  _getPrinterType(){
    localStorage.setItem("printer_type","A4");
    $.ajax({
      method: 'GET',
      url: 'http://localhost:5000/get-kiosk-info',
      success: (res) => {
        localStorage.setItem("printer_type",res.printer_type);
      },
      error: function(){
      },
      timeout: 3000
    });
  }
  _clearForm() {
    document.getElementById("form_field_id_scan").value = "";
    var fieldarr = this._slideshow._setFormLabel();
    $.each(fieldarr, function (key, data) {
      data['value'] = undefined;
    });
    document.getElementById("formfieldlabelform").reset();
    $("#label_exist_code").val('0');
  }
};
